module.exports = __webpack_public_path__ + "readmeTemplates/OSH_use.786fea944f92f24cbee6f576493624c8.md";